import { makeStyles } from "@material-ui/core";

export const progressStyle = makeStyles((theme) => ({
  root: (props) => ({
    color: props.color,
  }),
}));